import React from 'react';
import { useAuth } from '../hooks/useAuth';

interface AuthProviderProps {
  children: React.ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  // Initialize auth in background without blocking public pages
  useAuth();

  // Always render children immediately - let ProtectedRoute handle loading for auth-required pages
  return <>{children}</>;
};